import { z } from 'zod';
import { HouseEdgeBps } from './money';

/**
 * How a lobby payout grows while the round runs.
 *
 * The engine owns the shape and its parameters; the host only interpolates,
 * which is what keeps the next lobby game from needing host code. `type` is an
 * enum rather than an open record for exactly that reason.
 *
 * It lives in its own module because both sides of the platform need it: the
 * engine contract returns it, and the player-facing round events carry it so
 * the client animates the curve the engine actually chose.
 */
export const LobbyPayoutRule = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('MULTIPLIER_CURVE'),
    /** Milliseconds for the multiplier to double. multiplier = 2^(elapsedMs / doublingMs). */
    doublingMs: z.number().int().positive(),
    maxMultiplier: z.number().positive(),
    houseEdgeBps: HouseEdgeBps,
  }),
  z.object({
    type: z.literal('FIXED_TABLE'),
    /** Step function, ascending by `atMs`. The multiplier holds until the next step. */
    steps: z
      .array(
        z.object({
          atMs: z.number().int().nonnegative(),
          multiplier: z.number().positive(),
        }),
      )
      .min(1),
    houseEdgeBps: HouseEdgeBps,
  }),
]);
export type LobbyPayoutRule = z.infer<typeof LobbyPayoutRule>;
